import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { walletsQuery } from '@/features/wallet/wallet-api';
import { WalletScreen } from '@/features/wallet/wallet-screen';

export const Route = createFileRoute('/_app/wallet')({
  validateSearch: z.object({
    w: z
      .string()
      .regex(/^[a-f0-9]{24}$/)
      .optional(),
  }),
  loader: ({ context }) => context.queryClient.ensureQueryData(walletsQuery),
  component: WalletRoute,
});

function WalletRoute() {
  const { w } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { data: wallets } = useSuspenseQuery(walletsQuery);
  return (
    <WalletScreen
      wallets={wallets}
      selectedId={w}
      onSelect={(walletId) => void navigate({ search: { w: walletId }, replace: true })}
    />
  );
}
